export const BABY_CATEGORIES = ['baby_shower', 'baby_sprinkle', 'sip_and_see', 'gender_reveal'];
export const WEDDING_CATEGORIES = [
  'wedding_collection',
  'engagement',
  'save_the_date',
  'weddings',
  'bridal_shower',
];
export const GET_TOGETHER_CATEGORIES = ['housewarming', 'graduation'];

export const BIRTHDAY_CATEGORIES = [
  'birthday_forher',
  'birthday_forhim',
  'birthday_forkids',
  'babys_first',
  'birthday_milestones',
  'birthday_forteens',
];

// EVT-20361 Used to bucket for Amazon Giftlist
export const HOLIDAY_CATEGORIES = ['christmas', 'hanukkah', 'holiday_party', 'kwanzaa'];

export const EXCLUDED_CATEGORIES = ['funeral_memorial_service'];

export const should_show_registry_for_event_type = (event_type) =>
  !EXCLUDED_CATEGORIES.includes(event_type);
